module.exports = __webpack_public_path__ + "static/media/Item_Weapon_SCAR-L_C.2596eb4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_SCAR-L_C.png
// module id = ./src/assets/item/Weapon/Main/Item_Weapon_SCAR-L_C.png
// module chunks = 0